import { render, staticRenderFns } from "./SidebarSearchNew.vue?vue&type=template&id=63936970&scoped=true&"
import script from "./SidebarSearchNew.vue?vue&type=script&lang=js&"
export * from "./SidebarSearchNew.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSearchNew.vue?vue&type=style&index=0&id=63936970&scoped=true&lang=scss&"
import style1 from "./SidebarSearchNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63936970",
  null
  
)

export default component.exports